import React, { useMemo } from "react";
import { useDataContext } from "context/DataContext";
import { FlexBox } from "styles/global";
import {
  BigCard,
  // BlinkText,
  CardHeader,
} from "../DataFetcher/styled-datafetcher";
import ReactLoading from "react-loading";
import GetHospitalData from "../GetHospitalData/GetHospitalData";
import NewBigCardHospital from "./NewBigCardHospital";

interface HospitalCardProps {
  hospitalId: string;
}

const HospitalCard: React.FC<HospitalCardProps> = ({ hospitalId }) => {
  const {
    loading,
    metricasEspecialidades,
    // especialidadesColorMap
  } = useDataContext();

  const hospitalData = useMemo(
    () => GetHospitalData(hospitalId, metricasEspecialidades),
    [metricasEspecialidades, hospitalId]
  );

  if (loading)
    return (
      <ReactLoading
        type={"spinningBubbles"}
        color="#fff"
        height={667}
        width={375}
      />
    );

  if (hospitalData) {
    return (
      <NewBigCardHospital
        hospitalId={hospitalId}
        hospitalData={hospitalData}
        cardWidth="1600px"
      />
    );
  } else {
    return (
      <BigCard hospital="HRBZ">
        <FlexBox width="400px" height="200px" textAling="center">
          <CardHeader>
            <p>No momento não foi possível recuperar as informações.</p>
          </CardHeader>
        </FlexBox>
      </BigCard>
    );
  }
};

export default HospitalCard;
